import { render, staticRenderFns } from "./addOpencourse.vue?vue&type=template&id=6e50bd5e&"
import script from "./addOpencourse.vue?vue&type=script&lang=js&"
export * from "./addOpencourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports